/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Section_Ready_AccentInputs */

const en_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you are.`)
};

const es_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tú lo estés.`)
};

const de_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wann immer Sie es sind.`)
};

const zh_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们随时恭候。`)
};

const ar_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكون جاهزاً.`)
};

const fr_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vous l'êtes.`)
};

const vi_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bạn sẵn sàng.`)
};

const sw_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ukiwa tayari.`)
};

const th_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณพร้อม`)
};

const bs_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i vi budete.`)
};

const ja_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつでもどうぞ。`)
};

const ko_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제든지.`)
};

const pt_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quando você estiver.`)
};

const it_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quando lo sei tu.`)
};

const sv_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`när du är det.`)
};

const nl_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wanneer jij dat bent.`)
};

const da_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`når du er.`)
};

const nb_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`når du er.`)
};

const fi_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sinä olet valmis.`)
};

const pl_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gdy tylko zechcesz.`)
};

const ru_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`когда готовы вы.`)
};

const tr_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`biz de hazırız.`)
};

const hi_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम तैयार हैं।`)
};

const id_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda siap.`)
};

const ms_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anda bersedia.`)
};

const cs_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`až budete vy.`)
};

const el_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`όποτε είστε κι εσείς.`)
};

const he_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כשאתם מוכנים.`)
};

const af_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wanneer jy is.`)
};

const hu_home_section_ready_accent = /** @type {(inputs: Home_Section_Ready_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`amikor csak szeretnéd.`)
};

/**
* | output |
* | --- |
* | "you are." |
*
* @param {Home_Section_Ready_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_section_ready_accent = /** @type {((inputs?: Home_Section_Ready_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Section_Ready_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_section_ready_accent(inputs)
	if (locale === "de") return de_home_section_ready_accent(inputs)
	if (locale === "zh") return zh_home_section_ready_accent(inputs)
	if (locale === "ar") return ar_home_section_ready_accent(inputs)
	if (locale === "fr") return fr_home_section_ready_accent(inputs)
	if (locale === "vi") return vi_home_section_ready_accent(inputs)
	if (locale === "sw") return sw_home_section_ready_accent(inputs)
	if (locale === "th") return th_home_section_ready_accent(inputs)
	if (locale === "bs") return bs_home_section_ready_accent(inputs)
	if (locale === "ja") return ja_home_section_ready_accent(inputs)
	if (locale === "ko") return ko_home_section_ready_accent(inputs)
	if (locale === "pt") return pt_home_section_ready_accent(inputs)
	if (locale === "it") return it_home_section_ready_accent(inputs)
	if (locale === "sv") return sv_home_section_ready_accent(inputs)
	if (locale === "nl") return nl_home_section_ready_accent(inputs)
	if (locale === "da") return da_home_section_ready_accent(inputs)
	if (locale === "nb") return nb_home_section_ready_accent(inputs)
	if (locale === "fi") return fi_home_section_ready_accent(inputs)
	if (locale === "pl") return pl_home_section_ready_accent(inputs)
	if (locale === "ru") return ru_home_section_ready_accent(inputs)
	if (locale === "tr") return tr_home_section_ready_accent(inputs)
	if (locale === "hi") return hi_home_section_ready_accent(inputs)
	if (locale === "id") return id_home_section_ready_accent(inputs)
	if (locale === "ms") return ms_home_section_ready_accent(inputs)
	if (locale === "cs") return cs_home_section_ready_accent(inputs)
	if (locale === "el") return el_home_section_ready_accent(inputs)
	if (locale === "he") return he_home_section_ready_accent(inputs)
	if (locale === "af") return af_home_section_ready_accent(inputs)
	if (locale === "hu") return hu_home_section_ready_accent(inputs)
	return en_home_section_ready_accent(inputs)
});